export default "__VITE_ASSET__ujhFqW8V__"